export interface StripeProduct {
  id: string;
  name: string;
  description: string;
  priceInCents: number;
  currency: string;
  metadata?: Record<string, string>;
}

export const STRIPE_PRODUCTS: StripeProduct[] = [
  {
    id: 'consultation-session-60min',
    name: 'One-on-One Consultation Session (60 minutes)',
    description: 'A comprehensive 60-minute consultation session with Hailey to discuss your health goals, review your intake form, and create a personalized wellness plan.',
    priceInCents: 35000, // $350.00
    currency: 'usd',
    metadata: {
      duration: '60',
      type: 'consultation',
      category: 'session'
    }
  },
  {
    id: 'follow-up-session-30min',
    name: 'Follow-Up Session (30 minutes)',
    description: 'A 30-minute follow-up session to review your progress, adjust your wellness plan, and address any questions or concerns.',
    priceInCents: 7500, // $75.00
    currency: 'usd',
    metadata: {
      duration: '30',
      type: 'follow-up',
      category: 'session'
    }
  },
  {
    id: 'wellness-package-3sessions',
    name: 'Wellness Package (3 Sessions)',
    description: 'A comprehensive wellness package including one initial 60-minute consultation and two 30-minute follow-up sessions at a discounted rate.',
    priceInCents: 45000, // $450.00 (savings of $50 - total normally $500)
    currency: 'usd',
    metadata: {
      sessions: '3',
      type: 'package',
      category: 'bundle',
      savings: '5000'
    }
  }
];

export function getProductById(id: string): StripeProduct | undefined {
  return STRIPE_PRODUCTS.find(product => product.id === id);
}

export function getProductsByCategory(category: string): StripeProduct[] {
  return STRIPE_PRODUCTS.filter(product => product.metadata?.category === category);
}